import { Stars } from './Stars'

import type { RatingStats } from '../hooks/useReviewsActions'

interface RatingBreakdownProps {
  ratingStats: {
    five: RatingStats
    four: RatingStats
    three: RatingStats
    two: RatingStats
    one: RatingStats
  }
}

const RATINGS = [
  { stars: 5, key: 'five' as const },
  { stars: 4, key: 'four' as const },
  { stars: 3, key: 'three' as const },
  { stars: 2, key: 'two' as const },
  { stars: 1, key: 'one' as const },
]

export function RatingBreakdown({ ratingStats }: RatingBreakdownProps) {
  return (
    <div className="flex flex-col items-start justify-start gap-1">
      {RATINGS.map(({ stars, key }) => (
        <p key={stars} className="flex flex-row items-center justify-start gap-1.5">
          <span className="font-main-font text-xs font-bold w-3">{stars}</span>
          <Stars totalStars={stars} size="xs" />
          <span className="font-main-font text-xs font-bold">{ratingStats[key].percentage}%</span>
          <span className="font-main-font text-xs text-custom-gray">({ratingStats[key].voteCount})</span>
        </p>
      ))}
    </div>
  )
}
